export const shippingMethodsTabs = {
  shippingMethods: 'shippingMethods',
  availabilityCriteria: 'availabilityCriteria',
}

export const shippingMethodsTabList = [
  { label: 'Métodos de envío', value: shippingMethodsTabs.shippingMethods },
  { label: 'Criterios de disponibilidad', value: shippingMethodsTabs.availabilityCriteria },
]
